module.exports = __webpack_public_path__ + "static/media/Hero-Image.27d0336c.png";